import { Box } from '@mui/system';
import { verifyRegistration } from 'api/api';
import { useEffect } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { useSnackbar } from 'store/store';

export const UserVerify = () => {
  const queryClient = useQueryClient();
  const snackbar = useSnackbar();
  const navigate = useNavigate();
  const { token } = useParams<{ token: string }>();
  const { mutate } = useMutation('verifyRegistration', verifyRegistration, {
    onSuccess: (response) => {
      queryClient.invalidateQueries('profile');
      snackbar.open({
        type: 'success',
        message: response.data.message,
      });
      navigate('/');
    },
    onError: (error: any) => {
      console.error(error);
      snackbar.open({
        type: 'error',
        message: error?.message,
      });
      navigate('/');
    },
  });

  useEffect(() => {
    if (token) {
      mutate({ token });
    }
  }, []);

  return <Box>You will be redirected..</Box>;
};
